import { render, staticRenderFns } from "./SidebarHeader.vue?vue&type=template&id=2020a338"
import script from "./SidebarHeader.vue?vue&type=script&lang=js"
export * from "./SidebarHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports